import { c as _c } from "react/compiler-runtime";
import { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import CommonIntersectionElement from "../CommonIntersectionElement";
import FollowersList from "./FollowersList";
export default function FollowersListWrapper(t0) {
  const $ = _c(10);
  const {
    followers,
    loading,
    onBottomIntersection
  } = t0;
  let t1;
  if ($[0] !== followers) {
    t1 = <FollowersList followers={followers} />;
    $[0] = followers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== loading) {
    t2 = loading && <div className="tw-w-full tw-text-center tw-mt-8"><CircleLoader size={CircleLoaderSize.XXLARGE} /></div>;
    $[2] = loading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onBottomIntersection) {
    t3 = <CommonIntersectionElement onIntersection={onBottomIntersection} />;
    $[4] = onBottomIntersection;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-overflow-hidden tw-h-full">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}